
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';
import { Member } from '../types/memberTypes';

interface DeleteMemberDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  member: Member | null;
  onConfirm: () => void;
  source?: 'portfolio' | 'business';
}

const DeleteMemberDialog: React.FC<DeleteMemberDialogProps> = ({
  open,
  onOpenChange,
  member,
  onConfirm,
  source = 'portfolio'
}) => {
  if (!member) return null;
  
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <AlertTriangle className="h-6 w-6 text-red-500 mx-auto mb-2" />
          <DialogTitle className="text-center">Remove Member</DialogTitle>
          <DialogDescription className="text-center">
            Are you sure you want to remove {member.firstName} {member.lastName} from this {source}?
          </DialogDescription>
        </DialogHeader>
        
        <DialogFooter className="flex space-x-2 justify-end">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button type="button" variant="destructive" onClick={onConfirm}>
            Remove
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteMemberDialog;
